module.exports = __webpack_public_path__ + "static/media/gaxon.36251c7b.woff";